<template>

    <div class="w-full surface-100 
        py-5 xl:py-6 lg:py-6">
		<div class="center px-2 xl:pl-4 xl:pr-4">
			<div class="hidden xl:block p-2 text-800 font-semibold mb-5 align-items-center text-center
                text-3xl xl:text-6xl lg:text-6xl md:text-5xl sm:text-5xl">
				{{ content[lang_].title }}
			</div>
            <div class="block xl:hidden p-2 text-800 font-semibold mb-3 align-items-center text-center
                text-5xl xl:text-6xl lg:text-6xl md:text-5xl sm:text-5xl">
				{{ content[lang_].title_short }}
			</div>
			<div class="w-full flex flex-column px-1">
                <div class="flex flex-wrap justify-content-center
                    gap-0 xl:gap-5 lg:gap-4 md:gap-3 sm:gap-2">
                    <div class="flex 
                        w-6 xl:w-14rem lg:w-12rem md:w-12rem sm:max-w-12rem">
                        <div class="flex flex-column w-full surface-0
                            border-round-xl xl:border-round-2xl
                            border-ios-3xl
                            py-3 px-3 xl:py-4 xl:px-5
                            mb-2 mr-1 xl:m-0 lg:m-0 md:m-0 sm:m-0">
                            <span v-if="stat && stat.transfers" class="flex text-700 text-5xl xl:text-6xl font-medium mb-3">
                                {{ stat.transfers }}
                            </span>
                            <Skeleton v-else width="100%" height="25px" class="flex text-700 text-5xl xl:text-6xl font-medium mb-3" />
                            <span class="flex-grow-1"></span>
                            <span class="flex text-500 text-md">
                                {{ text.transfers.text[lang_] }}
                            </span>
                        </div>
                    </div>
                    <div class="flex 
                        w-6 xl:w-14rem lg:w-12rem md:w-12rem sm:max-w-12rem">
                        <div class="flex flex-column w-full surface-0
                            border-round-xl xl:border-round-2xl
                            border-ios-3xl
                            py-3 px-3 xl:py-4 xl:px-5
                            mb-2 ml-1 xl:m-0 lg:m-0 md:m-0 sm:m-0">
                            <span v-if="stat && stat.reviews" class="flex text-700 text-5xl xl:text-6xl font-medium mb-3">
                                {{ stat.reviews }}
                            </span>
                            <Skeleton v-else width="100%" height="25px" class="flex text-700 text-5xl xl:text-6xl font-medium mb-3" />
                            <span class="flex-grow-1"></span>
                            <span class="flex text-500 text-md">
                                {{ text.reviews.text[lang_] }}
                            </span>
                        </div>
                    </div>

                    <div class="flex 
                        w-6 xl:w-14rem lg:w-12rem md:w-12rem sm:max-w-12rem">
                        <div class="flex flex-column w-full surface-0
                            border-round-xl xl:border-round-2xl
                            border-ios-3xl    
                            py-3 px-3 xl:py-4 xl:px-5
                            mb-2 mr-1 xl:m-0 lg:m-0 md:m-0 sm:m-0">
                            <span v-if="stat" class="flex text-700 text-5xl xl:text-6xl font-medium mb-3">
                                5:00
                            </span>
                            <Skeleton v-else width="100%" height="25px" class="flex text-700 text-5xl xl:text-6xl font-medium mb-3" />
                            <span class="flex-grow-1"></span>
                            <span class="flex text-500 text-md">
                                {{ text.time.text[lang_] }}
                            </span>
                        </div>
                    </div>

                    <div class="flex 
                        w-6 xl:w-14rem lg:w-12rem md:w-12rem sm:max-w-12rem">
                        <div class="flex flex-column w-full surface-0
                            border-round-xl xl:border-round-2xl
                            border-ios-3xl
                            py-3 px-3 xl:py-4 xl:px-5
                            mb-2 ml-1 xl:m-0 lg:m-0 md:m-0 sm:m-0">
                            <span v-if="stat && stat.percent" class="flex text-700 text-5xl xl:text-6xl font-medium mb-3">
                                {{ stat.percent }}
                            </span>
                            <Skeleton v-else width="100%" height="25px" class="flex text-700 text-5xl xl:text-6xl font-medium mb-3" />
                            <div v-if="stat && stat.percent" class="bg-yellow-300 w-full mb-2" style="height:3px;">
                                <div class="bg-green-100" style="height:3px;" :style="`width:${stat.percent};`"></div>
                            </div>
                            <span class="flex-grow-1"></span>
                            <span class="flex text-500 text-md">
                                {{ text.positive.text[lang_] }}
                            </span>
                        </div>
                    </div>

                    <div class="flex 
                        w-6 xl:w-14rem lg:w-12rem md:w-12rem sm:max-w-12rem">
                        <div class="hidden xl:flex lg:flex md:flex sm:flex  
                            flex-column w-full surface-0
                            border-round-xl xl:border-round-2xl
                            border-ios-3xl
                            py-3 px-3 xl:py-4 xl:px-5
                            mb-2 mr-1 xl:m-0 lg:m-0 md:m-0 sm:m-0">
                            <span class="flex text-700 text-5xl xl:text-6xl font-medium mb-3">
                                {{ text.success.value }}%
                            </span>
                            <div v-if="true" class="bg-yellow-300 w-full mb-2" style="height:3px;">
                                <div class="bg-green-100" style="height:3px;" :style="`width:${100}%;`"></div>
                            </div>
                            <span class="flex-grow-1"></span>
                            <span class="flex text-500 text-md">
                                {{ text.success.text[lang_] }}
                            </span>
                        </div>
                    </div>

                    <div class="flex 
                        w-6 xl:w-14rem lg:w-12rem md:w-12rem sm:max-w-12rem">
                        <div class="hidden xl:flex lg:flex md:flex sm:flex  
                            flex-column w-full surface-0
                            border-round-xl xl:border-round-2xl
                            border-ios-3xl
                            py-3 px-3 xl:py-4 xl:px-5
                            mb-2 ml-1 xl:m-0 lg:m-0 md:m-0 sm:m-0">
                            <span class="flex text-700 text-4xl xl:text-5xl font-medium mb-3">
                                {{ text.clients.value }}
                            </span>
                            <span class="flex-grow-1"></span>
                            <span class="flex text-500 text-md">
                                {{ text.clients.text[lang_] }}
                            </span>
                        </div>
                    </div>

                    <div class="flex 
                        w-6 xl:w-14rem lg:w-12rem md:w-12rem sm:max-w-12rem">
                        <div class="hidden xl:flex lg:flex md:flex sm:flex 
                            flex-column w-full surface-0
                            border-round-xl xl:border-round-2xl
                            border-ios-3xl
                            py-3 px-3 xl:py-4 xl:px-5
                            mb-2 mr-1 xl:m-0 lg:m-0 md:m-0 sm:m-0">
                            <span class="flex text-700 text-4xl xl:text-5xl font-medium mb-3">
                                {{ text.age.value }} {{ text.year.text[lang_] }}
                            </span>
                            <span class="flex-grow-1"></span>
                            <span class="flex text-500 text-md">
                                {{ text.age.text[lang_] }}
                            </span>
                        </div>
                    </div>

                    <div class="flex 
                        w-6 xl:w-14rem lg:w-12rem md:w-12rem sm:max-w-12rem">
                        <div class="hidden xl:flex lg:flex md:flex sm:flex 
                            flex-column w-full surface-0
                            border-round-xl xl:border-round-2xl
                            border-ios-3xl
                            py-3 px-3 xl:py-4 xl:px-5
                            mb-2 mr-1 xl:m-0 lg:m-0 md:m-0 sm:m-0">
                            <span class="flex text-700 text-4xl xl:text-5xl font-medium mb-3">
                                {{ text.warrenty.value }}
                            </span>
                            <span class="flex-grow-1"></span>
                            <span class="flex text-500 text-md">
                                {{ text.warrenty.text[lang_] }}
                            </span>
                        </div>
                    </div>

                </div> 
			</div>
		</div>
	</div>	

</template>

<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'
export default {
    data(){
        return {
            stat: null,
			content: {
				ru: {
					title: 'Статистика сервиса',
                    title_short: 'Статистика',
				},
				en: {
					title: 'Service statistics',
                    title_short: 'Statistics',
				},
			},
            text: {
                transfers: {
                    text: {
                        ru: 'Всего переводов',
                        en: 'Total transfers',
                    }
                },
                reviews: {
                    text: {
                        ru: 'Всего отзывов',
                        en: 'Total reviews',
                    }
                },
                time: {
                    text: {
                        ru: 'Среднее время перевода',
                        en: 'Average transfer time',
                    }
                },
                positive: {
                    text: {
                        ru: 'Положительных оценок',
                        en: 'Positive ratings',
                    }
                },
                success: {
                    value: 100,
                    text: {
                        ru: 'Успешных переводов',
                        en: 'Successful transfers',
                    }
                },
                clients: {
                    value: '>5000',
                    text: {
                        ru: 'Клиентов сервиса',
                        en: 'Service clients',
                    }
                },
                age: {
                    value: '2',
                    text: {
                        ru: 'Время существования сервиса',
                        en: 'Service age',
                    }
                },
                year: {
                    value: '2',
                    text: {
                        ru: 'года',
                        en: 'years',
                    }
                },
                warrenty: {
                    value: '100%',
                    text: {
                        ru: 'Гарантия на возврат средств',
                        en: 'Money back guarantee',
                    }
                },
            }
        }
    },
	computed: {
        lang_() {
            return (this.$i18n.locale) ? this.$i18n.locale : 'ru'
        },  
		isAuth: function () { return this.$store.getters.isAuthenticated },
    },
	methods: {
		formateTimer(time) {
            const time_seconds = time / 1000
            let minutes = Math.floor(time_seconds / 60)
            let seconds = Math.floor(time_seconds % 60)
            if(seconds.toString().length==1) seconds = '0'+seconds
            return `${minutes}:${seconds}`
        },
	},
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()

        const stat = await this.connect.get_reviews_stat().then(res=>res)
        if(stat.result && stat.data){
            // считаем время
            const calc_time = this.formateTimer(stat.data.time)

            // считаем процент положительных отзывов
            const percent = Math.round((stat.data.good / stat.data.reviews) * 100)

            this.stat = {
                transfers: stat.data.transfers,
                reviews: stat.data.reviews,
                // time: calc_time,
                percent: `${percent}%`,
            }
        }
    }
}
</script>
